module.exports = __webpack_public_path__ + "img/T4-C-xs_5.7e67bce8.png";